const getMyCard = state => state.card
const getMyCardList = state => state.card_list

export default {
    getMyCard,
    getMyCardList,
}